<template>
  <v-card
    class="ma-0 mt-0"
    width="100%"
    style="overflow-y: hidden !important;min-height: 200px"
    flat
  >
    <v-row
      v-show="!showSelectedItems"
      style="border-bottom: 1px solid #818181;position: fixed;width: 100%;"
      class="mx-0 mt-0 mb-0"
    >
      <v-col
        cols="12"
        class="pa-0 px-1 mb-1 d-flex"
      >
        <v-text-field
          ref="searchRef"
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          :autofocus="(isMobile ? false : true)"
          flat
          height="45"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
          hide-details
          clearable
          :loading="loading"
        />
        <v-btn
          icon
          @click="showFilter = !showFilter"
        >
          <v-icon
            :color="(showFilter ? 'primary' : 'grey')"
            style="font-size: 26px;margin-top: 2px"
          >
            mdi-filter-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        v-show="showFilter"
        cols="12"
        class="pa-0 px-1"
      >
        <v-chip-group
          v-model="selectGroup"
          active-class="primary--text"
        >
          <v-chip
            v-for="(group, i) in groups"
            :key="i"
            large
            color="primary"
            outlined
            class="ms-0 me-2"
            style="height: 40px"
            :value="group"
          >
            <p
              class="mb-0"
              style="font-size: 15px"
            >
              {{ group.name }}
            </p>
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row
      class="mx-0"
      :style="{'margin-top' : (showFilter ? '116px' : '59px')}"
    >
      <v-col
        cols="12"
        class="d-flex pt-0 px-0"
      >
        <v-item-group
          mandatory
          class="mt-1 mx-0"
          style="width: 100%"
        >
          <v-row
            class="mx-0"
            style="overflow-y: scroll;overflow-x: hidden;border-bottom: 0px solid #e3e3e3;"
            :style="{height : height}"
          >
            <v-col
              v-for="(item, i) in items"
              :key="i"
              cols="12"
              class="pa-0 px-1 mb-3"
            >
              <v-card
                flat
                width="100%"
                class="d-flex my-0 px-0 pa-2"
              >
                <v-col
                  class="pa-0"
                  style="max-width: 120px !important;"
                >
                  <v-avatar
                    tile
                    width="110"
                    height="110"
                    style="border-radius: 5px !important;"
                  >
                    <img
                      :src="(item.avatar ? item.avatar.link : '/img/noImage.png')"
                      alt="John"
                    >
                  </v-avatar>
                </v-col>
                <v-col
                  class="pa-0"
                >
                  <div
                    class="pe-2"
                    style="font-size: 16px;line-height: 1.5;"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    class="pe-2 mt-1"
                    style="font-size: 12px;line-height: 1.5;color: #0066FF !important"
                  >
                    {{ $t('stock') }} : {{item.countStock}}
                  </div>
                </v-col>
              </v-card>
              <v-card
                class="d-flex my-0 mb-3"
                flat
              >
                <v-card
                  class="pa-2 pt-0 px-0 d-flex my-0"
                  width="50%"
                  flat
                >
                  <v-btn
                    small
                    color="green"
                    height="40"
                    outlined
                    style="padding: 0px !important;min-width: 40px !important;"
                    @click="addCount(item)"
                  >
                    <v-icon
                      dark
                    >
                      mdi-plus
                    </v-icon>
                  </v-btn>
                  <v-text-field
                    v-model="item.count"
                    height="40"
                    dense
                    solo
                    hide-details
                    flat
                    class="dense mx-1"
                    :suffix="(item.unit ? item.unit.fame : '')"
                    :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                    :placeholder="$t('count')"
                    type="number"
                    @blur="checkStock(item)"
                  />
                  <v-btn
                    small
                    outlined
                    color="pink"
                    height="40"
                    style="padding: 0px !important;min-width: 40px !important;padding-top: 2px"
                    class="me-1"
                    @click="minusCount(item)"
                  >
                    <v-icon
                      dark
                    >
                      {{ (item.count == 1 ? 'mdi-trash-can-outline' : 'mdi-minus') }}
                    </v-icon>
                  </v-btn>
                </v-card>
                <v-card
                  class="pa-2 my-0 pt-0 py-0"
                  flat
                  width="50%"
                >
                  <p class="text-left text mb-0">
                    {{ $t('fee') }} : <span style="font-size: 14px">{{ $numberFormat(item.price) }} </span>
                  </p>
                  <p class="text-left mb-0">
                    {{ $t('sum') }} : <span style="font-size: 16px;font-weight: bold;">{{ $numberFormat(item.price*item.count) }} </span>{{ $store.state.currency.symbol }}
                  </p>
                </v-card>
              </v-card>
              <v-divider />
            </v-col>
            <v-col
              v-if="items.length > 0 && last_page > page"
              class="d-flex pa-1 text-center"
              cols="12"
            >
              <v-spacer />
              <div
                v-observe-visibility="{
                  callback: visibilityChanged
                }"
                width="100%"
                height="40px"
                align="center"
                class="d-flex my-0 pa-2 text-center"
              >
                <v-progress-circular
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                />
              </div>
              <v-spacer />
            </v-col>
          </v-row>
        </v-item-group>
      </v-col>
    </v-row>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="565px"
      >
        <v-btn
          class="mt-0"
          text
          height="55"
          color="pink"
          style="font-size: 16px"
          @click="sheet = !sheet"
        >
          {{ $t('closeList') }}
        </v-btn>
        <v-divider />
        <v-row class="mx-0 mt-1 pb-3">
          <product-seleted :selected-items="selectedItem" />
        </v-row>
        <v-card
          width="100%"
          height="48"
          style="box-shadow: 1px 0 10px rgba(51,51,51,.251);margin: 8px"
          class="my-0 mx-0 pa-1 d-flex justify-space-between"
        >
          <v-card
            class="pa-2 pt-1 my-0"
            flat
            height="30"
            style="background-color: transparent"
          >
            {{ selectedItem.length }} {{ $t('productInList') }}
          </v-card>
          <v-card
            class="pa-2  pt-1 my-0"
            flat
            height="30"
            style="font-size: 16px;background-color: transparent;"
          >
            <strong style="color: rgb(76, 175, 80);font-size: 20px">{{ $numberFormat(sumAmount) }}</strong> {{ $store.state.currency.symbol }}
          </v-card>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog
      v-model="productDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="productDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Product from '../../../pages/product/product'
  import ProductSeleted from './mProductSeleted.vue'
  export default {
    components: {
      ProductSeleted,
      Product,
    },
    props: ['header', 'customer', 'data', 'heightProp', 'itemCount', 'typeProp',
            'scaleProp', 'sumAmount', 'showSelectedItems'],
    data () {
      return {
        page: 0,
        showFilter: false,
        tempItems: null,
        selectByBarcode: true,
        last_page: 1,
        offline: false,
        options: {
          locale: 'en-US',
          prefix: '',
          suffix: '  ریال  ',
          precision: 0,
        },
        feeRules: [
          v => !!v || 'Name is required',
          v => (v && v > 0) || 'Name must be less than 10 characters',
        ],
        productTimer: 0,
        listHeight: 360,
        heightSelectProduct: null,
        snakbarText: null,
        groups: null,
        selectGroup: null,
        showAlert: false,
        productDialog: false,
        disabled: false,
        taxDialog: false,
        snakbar: false,
        sumDiscountPercent: null,
        bottomPanel: null,
        date: null,
        snakbarColor: null,
        trip: {
          name: '',
          location: null,
          start: null,
          end: null,
        },
        locations: ['Australia', 'Barbados', 'Chile', 'Denmark', 'Ecuador', 'France'],
        items: [],
        bottomSummeryHeight: 'auto',
        selected: 0,
        selectedItem: [],
        searchTrigger: false,
        showSelectedItem: false,
        submitLoading: false,
        newProduct: null,
        group: null,
        cat1: null,
        cat2: null,
        search: null,
        list: null,
        type: 'productService',
        loading: false,
        sheet: false,
        bottomSummery: false,
        availableGoods: false,
        sumPrice: 0,
        selectedItems: [],
        sumDiscount: 0,
        sumTax: 0,
        more: true,
        tax: false,
        groupId: [],
        discountRules: [
          v => (v && v <= 100) || 'Max should not be above £50,000',
        ],
      }
    },
    computed: {
      height: function () {
        if (this.showFilter && this.selectedItem.length > 0) {
          return 'calc(100vh - 260px)'
        }
        if (this.showFilter && this.selectedItem.length === 0) {
          return 'calc(100vh - 170px)'
        }
        if (this.selectedItem.length > 0) {
          return 'calc(100vh - 206px)'
        }
        return 'calc(100vh - 120px)'
      },
    },
    watch: {
      showSelectedItems (val) {
        if (val) {
          this.sheet = true
          // this.tempItems = this.items
          // this.items = this.selectedItem
        } else {
          this.sheet = false
          // this.items = this.tempItems
        }
      },
      items: {
        handler () {
        },
        deep: true,
      },
      selectGroup (Val, oldVal) {
        this.items = []
        this.page = 0
        this.selectByBarcode = false
        if (this.selectGroup) {
          this.items = []
          this.group = this.selectGroup
        }
        if (this.offline) {
          this.getItems()
        } else {
          this.getItems()
        }
      },
      group (Val, oldVal) {
        if (this.$refs.refCat2 && this.$refs.refCat1) {
          if (Val) {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
            this.$refs.refCat1.initList = false
            this.$refs.refCat1.getItems()
          } else {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
          }
        }
      },
      cat1 (Val, oldVal) {
        if (this.$refs.refCat2) {
          if (Val) {
            this.$refs.refCat2.clear()
            this.$refs.refCat2.initList = false
            this.$refs.refCat2.getItems()
          } else {
            this.$refs.refCat2.clear()
          }
        }
      },
      data () {
      },
      newProduct  () {
        this.search = this.newProduct.name
        this.searchTrigger = true
        this.searchItems()
        this.productDialog = false
      },
      entrepot  () {
        this.search = ''
      // this.searchItems()
      },
      availableGoods () {
        this.items = []
        this.page = 1
        this.lastPage = 100000
        this.searchItems()
      },
      search (val, oldVal) {
        var app = this
        app.showAlert = false
        app.items = []
        app.page = 0
        app.getItems()
      },
      offline (val) {
        this.items = []
        if (val) {
          this.getItems()
        }
        this.$emit('setOffline', val)
      },
      sheet () {
        if (this.sheet === false) {
          this.$emit('showSelectedItems', false)
          // this.searchTrigger = true
          // this.page = 1
          // this.items = []
          // this.lastPage = 100000
          // this.initList = false
          // this.getItems()
        }
      },
      scaleProp (val) {
        this.onResize()
      },
      showFilter (val) {
        if (!val) {
          this.group = null
          this.page = 0
          this.items = []
          this.getItems()
        }
      },
    },
    activated: function () {
    // this.countCheck()
    },
    mounted () {
      this.getGroups()
      // this.offline = true
      this.setDefaultCooki()
      this.getItems()
      // if (this.offline) {
      //   this.getItemsOffline()
      // }
    // if (this.selectGroup) {
    //   this.items = []
    //   this.group = this.selectGroup
    // }
    // this.search = ''
    },
    beforeRouteLeave (to, from, next) {
      var goNext = false
      if (this.items) {
        this.items.map(function (value, key) {
          if (value.dialog) {
            value.dialog = false
            goNext = true
          }
        })
      }

      if (this.bottomPanel === 0) {
        this.bottomPanel = null
        goNext = true
      }
      if (!goNext) {
        next()
      } else {
        next(false)
      }
    },
    created () {
    // window.addEventListener('resize', this.resizeHeightBody)
    },
    destroyed () {
    // window.removeEventListener('resize', this.resizeHeightBody)
    },
    beforeDestroy () {
      // window.removeEventListener('resize', this.onResize)
    },
    methods: {
      checkStock (item) {
        if (this.$store.state.negative_inventory === 'no' && item.countStock < item.count) {
          this.snakbarText = this.$t('alert-inventory-is-not-enough')
          this.snakbarColor = 'pink'
          this.snakbar = true
          item.count = 0
          return false
        }
        this.setItem(item)
      },
      addCount (item) {
        if (this.$store.state.negative_inventory === 'no' && item.countStock < item.count + 1) {
          return false
        }
        item.count++
        this.setItem(item)
      },
      setItem (item) {
        var index = this.selectedItem.findIndex(x => x.id === item.id)
        if (index < 0) {
          item.product = {
            id: item.id,
            name: item.name,
            fin_id: item.fin_id,
            type: item.type,
            unit_id: item.unit_id,
            unit: item.unit,
          }
          this.selectedItem.push(item)
        } else {
          this.selectedItem[index].count = item.count
        }
        this.$emit('input', this.selectedItem)
      },
      removeItem (item) {
        var index = this.selectedItem.findIndex(x => x.id === item.id)
        if (index > -1) {
          this.selectedItem.splice(index, 1)
        }
        this.$emit('input', this.selectedItem)
      },
      minusCount (item) {
        if (item.count > 0) {
          item.count--
          this.setItem(item)
          if (item.count === 0) {
            this.removeItem(item)
          }
        }
      },
      onResize () {
        var minus = 240
        var minusDesctop = 317
        if (window.innerHeight < 800) {
          minus = 260
        }
        if (this.scaleProp) {
          minus = 240
          minusDesctop = 275
        }
        this.heightSelectProduct = (this.isMobile ? window.innerHeight - minus : window.innerHeight - minusDesctop)
      },
      clearSearch () {
        this.initList = false
        this.getItems()
      },
      add (item) {
        this.loading = false
        this.$emit('append', item)
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems1 () {
        var timeout = 1000
        if (this.selectByBarcode) {
          timeout = 50
        }
        this.loading = true
        this.showAlert = false
        if (this.page === 1 && this.search == null && this.initList && this.selectByBarcode) {
          return false
        }
        this.initList = true
        var app = this
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              search: app.search,
              page: app.page,
              count: 5,
              select: 'mobileProductService',
              formType: app.typeProp,
              currency: app.currency,
              data: app.data,
              addInvoiceItem: 'active',
              parent_id: app.parent,
              group: (app.group ? app.group.id : null),
              cat1: (app.cat1 ? app.cat1.id : null),
              cat2: (app.cat2 ? app.cat2 : null),
            },
          })
            .then(res => {
              res = res.data
              var setDef = false
              if (app.setInit && app.page === 1) {
                app.items = []
                setDef = true
              }
              app.last_page = res.last_page
              if (app.items && app.items.length > 0) {
                app.items = [
                  ...app.items,
                  ...Array.from(res.data),
                ]
              } else {
                app.items = res.data
              }
              if (app.items && res.total > app.items.length) {
                app.page++
              }
              if (res.last_page === res.current_page) {
                app.last_page = 1
                app.more = false
              }
              if (setDef) {
                app.model = app.items[0]
              }
              if (res.data && res.data.length > 0) {
                app.notFind = null
                if (app.selectByBarcode && app.items.length === 1) {
                  app.add(app.items[0])
                  app.search = null
                }
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(function () {
              app.disabled = false
              app.loading = false
              if (app.items && app.items.length === 0) {
                app.showAlert = true
                if (app.selectByBarcode) {
                  setTimeout(function () {
                    app.search = null
                  }, 1500)
                }
              }
            })
        }, timeout)
      },
      getGroups () {
        var app = this
        var connection = this.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'productGroup',
        }).then(function (data) {
          app.groups = data
          app.groupId.push(null)
          app.groups.map(function (value) {
            app.groupId.push(value.id)
          })
        })
      },
      getItems () {
        var app = this
        var connection = this.DB
        var group = (app.group ? [app.group.id] : null)
        connection.openDb('db_' + this.$store.state.userId)
        connection.count((group ? {
          from: 'products',
          where: {
            name: {
              like: '%' + (app.search ? app.search : '') + '%',
            },
            group_id: { in: group },
          },
        }
          : {
            from: 'products',
            where: {
              name: {
                like: '%' + (app.search ? app.search : '') + '%',
              },
            },
          })).then(function (data) {
          app.last_page = Math.ceil(data / 10)
        })
        connection.select((group ? {
          from: 'products',
          skip: app.page * 10,
          limit: 10,
          where: {
            name: {
              like: '%' + (app.search ? app.search : '') + '%',
            },
            group_id: { in: group },
          },
        }
          : {
            from: 'products',
            skip: app.page * 10,
            limit: 10,
            where: {
              name: {
                like: '%' + (app.search ? app.search : '') + '%',
              },
            },
          })).then(function (data) {
          if (app.last_page > app.page) {
            app.page++
          }
          app.items = [
            ...app.items,
            ...data,
          ]
        })
      },
      getItemsOffline1 () {
        var timeout = 1000
        if (this.selectByBarcode) {
          timeout = 500
        }
        var app = this
        app.loading = true
        clearTimeout(this.productTimer)
        this.productTimer = setTimeout(function () {
          var products = JSON.parse(localStorage.getItem('products'))
          if (app.selectGroup && products) {
            products = products.filter(function (product) {
              return product.group_id === app.selectGroup.id
            })
          }
          if (app.search && products) {
            products = products.filter(function (product) {
              return product.name.includes(app.search) || product.code === parseFloat(app.search) || product.barcode === app.search
            })
          }
          app.items = products
          if (app.items > 0) {
            app.notFind = null
            if (app.selectByBarcode && app.items.length === 1) {
              app.add(app.items[0])
              app.search = null
            }
          }
          app.loading = false
        }, timeout)
      },
      clearSelectedItems () {
        this.page = 0
        this.selectedItem = []
        this.tempItems = []
        this.items = []
        this.getItems()
      },
    },
  }
</script>

<style>
.product-item-category {
  border: 1px solid #e3e3e3;
  border-radius: 5px;
}
.dense > .v-input__control {
  min-height: 30px !important;
}
.border-item {
  border: #0066FF solid 1px;
}
.bottomSummery {
  position: fixed;
  height: auto;
  bottom: 0;
  width: 100%;
}
</style>
